<button class="btn btn-primary btn-dashboard mt-2 import-trigger" type="button" (click)="open()">
  <i class="las la-file-import"></i>{{ config.title }}
</button>

@if (visible) {
  <div class="modal fade show import-modal" role="dialog" tabindex="-1" [ngStyle]="{display: 'block'}" (click)="close()">
    <div class="modal-dialog modal-lg modal-dialog-centered" role="document" (click)="$event.stopPropagation()">
      <div class="modal-content">
        <div class="modal-header">
          <div><h5 class="modal-title">{{ config.title }}</h5><p class="mb-0 text-muted">{{ config.subtitle }}</p></div>
          <button class="close" type="button" (click)="close()" aria-label="Close"><span>&times;</span></button>
        </div>
        <div class="modal-body">
          <div class="import-rules">
            <strong>Read through the rules before uploading your file.</strong>
            <ul>
              <li>The file format should be <strong>.csv</strong>.</li>
              <li>The required columns are: <strong>{{ config.columns }}</strong>.</li>
              @for (rule of config.rules; track rule) { <li>{{ rule }}</li> }
              <li>If you still have questions, You can <a [href]="config.sampleUrl" download target="_blank" rel="noopener">Download</a> the sample file from here.</li>
            </ul>
          </div>
          <label class="mt-4 font-weight-bold">Import from CSV file*</label>
          <div class="import-actions">
            <input type="file" accept=".csv,text/csv" class="form-control" (change)="selectFile($event)" />
            <a class="btn btn-outline-primary" [class.disabled]="!url" [href]="url || null" target="_blank" rel="noopener">View uploaded file</a>
            <button class="btn btn-primary btn-dashboard ml-0" type="button" [disabled]="!url || uploading || importing" (click)="submit()">{{ importing ? 'Importing...' : 'Upload file' }}</button>
          </div>
          @if (uploading) { <div class="progress mt-3"><div class="progress-bar" [style.width.%]="progress">{{ progress }}%</div></div> }
        </div>
        <div class="modal-footer"><button class="btn btn-outline-secondary" type="button" [disabled]="uploading || importing" (click)="close()">Cancel</button></div>
      </div>
    </div>
  </div>
}
